import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };
  
  const navClass = scrolled 
    ? "navbar navbar-expand-lg fixed-top shadow-sm py-3 bg-white"
    : "navbar navbar-expand-lg fixed-top py-3 bg-white";
    
  return (
    <nav className={navClass}>
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src="/images/sp_mark_v2.svg" alt="" width="32" height="32" className="me-2" />
          <span className="fw-bold">Sustainability <span className="text-primary">Pros</span></span>
        </Link>
        
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleMenu}
          aria-expanded={isOpen ? "true" : "false"}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link 
                to="/" 
                className={`nav-link px-3 ${location.pathname === '/' ? 'active fw-semibold' : ''}`}
                onClick={closeMenu}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/about" 
                className={`nav-link px-3 ${location.pathname === '/about' ? 'active fw-semibold' : ''}`}
                onClick={closeMenu}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/services" 
                className={`nav-link px-3 ${location.pathname === '/services' ? 'active fw-semibold' : ''}`}
                onClick={closeMenu}
              >
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/projects"
                className={`nav-link px-3 ${location.pathname === '/projects' ? 'active fw-semibold' : ''}`}
                onClick={closeMenu}
              >
                Projects
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/mep-tools"
                className={`nav-link px-3 ${location.pathname === '/mep-tools' ? 'active fw-semibold' : ''}`}
                onClick={closeMenu}
              >
                MEP Tools
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className={`nav-link px-3 ${location.pathname === '/contact' ? 'active fw-semibold' : ''}`}
                onClick={closeMenu}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;